// assets/anzza-about.js

(function () {
  // ── Helpers ──────────────────────────────────────────────
  function lerp(a, b, t) {
    return a + (b - a) * t;
  }

  function inverseLerp(a, b, v) {
    return Math.min(1, Math.max(0, (v - a) / (b - a)));
  }

  function hexToRgb(hex) {
    hex = hex.replace("#", "");
    if (hex.length === 3)
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    const n = parseInt(hex, 16);
    return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
  }

  function lerpColor(hex1, hex2, t) {
    const a = hexToRgb(hex1);
    const b = hexToRgb(hex2);
    return `rgb(${Math.round(lerp(a.r, b.r, t))}, ${Math.round(
      lerp(a.g, b.g, t)
    )}, ${Math.round(lerp(a.b, b.b, t))})`;
  }

  // ── Heading animation ─────────────────────────────────────
  function animateHeading() {
    const lines = document.querySelectorAll(".anzza-about-heading-line");
    if (!lines.length) return;
    lines.forEach(function (line) {
      const index = parseInt(line.getAttribute("data-index"));
      gsap.from(line, {
        x: index === 0 ? -300 : 500,
        opacity: 0,
        duration: 0.8,
        ease: "power3.out",
        delay: 0.3 + index * 0.15,
      });
    });
  }

  // ── Main init ─────────────────────────────────────────────
  function init() {
    if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") {
      setTimeout(init, 100);
      return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const slider = document.getElementById("anzza-about-hero");
    const track = document.getElementById("anzza-about-track");
    if (!slider || !track) return;

    // ── Desktop only ──
    if (window.innerWidth < 768) return;

    // ── Set track width on desktop only ──
    if (window.innerWidth >= 768) {
      track.style.width = "360vw";
    }

    // ── Elements ──
    const panel1Deco = document.getElementById("anzza-p1-deco");
    const panel1ImgWrap = document.getElementById("anzza-p1-img-wrap");
    const panel3Deco = document.getElementById("anzza-p3-deco");
    const panel4Bg = document.getElementById("anzza-p4-bg");
    const panel4Text = document.getElementById("anzza-p4-text");
    const bgEl = document.getElementById("anzza-about-bg");

    // ── Colors ──
    const color1 = bgEl ? bgEl.getAttribute("data-color-1") : "#8B0000";
    const color2 = bgEl ? bgEl.getAttribute("data-color-2") : "#E8527A";
    const color3 = bgEl ? bgEl.getAttribute("data-color-3") : "#F5F0E8";

    // ── Scroll distances ──
    const totalScroll = track.scrollWidth - window.innerWidth;

    // ── Panel fractions of total track width ──
    const trackWidth = track.scrollWidth;
    const panel1End = window.innerWidth / trackWidth;
    const panel2End = (window.innerWidth * 2) / trackWidth;
    const panel3End =
      (window.innerWidth * 2 + window.innerWidth * 0.6) / trackWidth;

    // ── Set initial states ──
    if (panel4Bg) {
      gsap.set(panel4Bg, { scale: 1.2, transformOrigin: "center center" });
    }
    if (panel4Text) {
      gsap.set(panel4Text, { scale: 0.8, transformOrigin: "center bottom" });
    }

    ScrollTrigger.getAll().forEach(function (st) {
      if (st.trigger === slider) st.kill();
    });

    ScrollTrigger.create({
      trigger: slider,
      start: "top top",
      end: () => "+=" + totalScroll,
      scrub: true,
      pin: true,
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: function (self) {
        const progress = self.progress;

        // ── Move track ──
        gsap.set(track, {
          x: -(progress * totalScroll),
        });

        // ── Panel 1 progress (0 = fully in, 1 = fully out) ──
        const p1progress = progress / panel1End;

        // ── Panel 1 — DECO scale ──
        if (panel1Deco) {
          const decoT = inverseLerp(0.1, 0.5, p1progress);
          const decoScale = lerp(1, 0.85, decoT);
          gsap.to(panel1Deco, {
            scale: decoScale,
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }

        // ── Panel 1 — Image container shrink ──
        if (panel1ImgWrap) {
          const imgT = inverseLerp(0.2, 0.7, p1progress);
          const imgHeight = lerp(100, 50, imgT);
          const imgWidth = lerp(100, 80, imgT);
          const imgRadius = lerp(30, 0, imgT);
          gsap.to(panel1ImgWrap, {
            height: imgHeight + "vh",
            width: imgWidth + "%",
            borderRadius: imgRadius + "px",
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }

        // ── Panel 1 — BG color ──
        if (bgEl) {
          let bgColor;
          if (p1progress < 0.4) {
            bgColor = color1;
          } else if (p1progress <= 0.7) {
            const t = inverseLerp(0.4, 0.7, p1progress);
            bgColor = lerpColor(color1, color2, t);
          } else {
            const t = inverseLerp(0.7, 1.0, p1progress);
            bgColor = lerpColor(color2, color3, t);
          }
          gsap.to(bgEl, {
            backgroundColor: bgColor,
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }

        // ── Panel 3 — Deco move left + scale up ──
        if (panel3Deco) {
          const panel3Start = panel2End + (panel3End - panel2End) * 0.2;
          const p3progress = inverseLerp(panel3Start, panel3End, progress);
          const decoX = lerp(0, -15, p3progress);
          const decoScale = lerp(1, 1.2, p3progress);
          gsap.to(panel3Deco, {
            xPercent: decoX,
            scale: decoScale,
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }

        // ── Panel 4 — BG scale 1.2 → 1, text scale 0.8 → 1 ──
        const panel4Start = panel3End + (1 - panel3End) * 0.3;
        const panel4Stop = panel3End + (1 - panel3End) * 0.9;
        const p4progress = inverseLerp(panel4Start, panel4Stop, progress);

        if (panel4Bg) {
          gsap.to(panel4Bg, {
            scale: lerp(1.2, 1, p4progress),
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }

        if (panel4Text) {
          gsap.to(panel4Text, {
            scale: lerp(0.8, 1, p4progress),
            duration: 0.5,
            ease: "power2.out",
            overwrite: true,
          });
        }
      },
    });

    animateHeading();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e.target.querySelector("#anzza-about-hero")) init();
  });
})();
